import { mdiImagePlus } from "@mdi/js";
import Icon from "@mdi/react";
import { Textarea, Input } from "../../../components/textfield";
import MainButton from "../../../components/button/mainButton";
import HeaderBar from "../../../components/header/headerBar";
import { useEffect, useState, useRef } from "react";
import { getLocalUrl } from "../../../functions";
import "../../../assets/styles/admin/opd.scss";
import { useLocation, useHistory, useParams } from "react-router-dom";
import axios from "axios";
import {
  Form,
  Select,
  Typography,
  message,
  DatePicker,
  InputNumber,
} from "antd";

const messageText = "กรุณากรอกข้อมูล!";

const Complication = () => {
  const fileInput: any = useRef();
  const inputFileImage: any = useRef();

  interface ParamsType {
    courseRecordId: string;
  }
  const { courseRecordId } = useParams<ParamsType>();
  const [form] = Form.useForm();

  const [Channel, setChannel] = useState<string>("");
  const [FirstName, setFirstName] = useState<string>("");
  const [ComplicationNumber, setComplicationNumber] = useState<string>("");
  const [DateMain, setDateMain] = useState<string>("");
  const [Status, setStatus] = useState<string>("");
  const [DateBefore, setDateBefore] = useState<string>("");
  const [DateAfter, setDateAfter] = useState<string>("");
  const [uploadFileBefore, setUploadFileBefore] = useState<any>("");
  const [uploadFileAfter, setUploadFileAfter] = useState<any>("");
  const [ProductDetailBefore, setProductDetailBefore] = useState<string>("");
  const [ProductDetailAfter, setProductDetailAfter] = useState<string>("");
  const [Complication, setComplication] = useState<string>("");
  const [CommentDoctor, setCommentDoctor] = useState<string>("");
  const [CommentDirector, setCommentDirector] = useState<string>("");
  const [ManagingDirector, setManagingDirector] = useState<string>("");
  const [CostEstiMate, setCostEstiMate] = useState<string>("");
  const [Organizer, setOrganizer] = useState<string>("");
  const [Sale, setSale] = useState<string>("");
  const [state, setState] = useState<any>({});

  const getAPIs = async () => {
    setChannel("EK-CNT60100015");
    setComplicationNumber("CO-000000589");
    setOrganizer("Dr.Harirak Artamnuayvipas");
    setSale("Dr.Harirak Artamnuayvipas");
    setStatus("SUCCESS");

    try {
      const { data } = await axios.get(
        `/member-so/request-complication?courseRecordId=${courseRecordId}`
      );
      if (!data) return;
    } catch (err: any) {
      console.log("err =>", err);
    }
  };

  const onUploadIconClick = () => {
    console.log("click...");
    fileInput.current.click();
  };

  const onUploadFileImage = () => {
    inputFileImage.current.click();
  };

  const onFileInputChange = (e: any) => {
    const { files } = e.target;
    console.log("on file input change =>", files);
    const file = files && files.length ? files[0] : null;
    const imageUrl = getLocalUrl(file);
    console.log("image url =>", imageUrl);
    setUploadFileBefore(imageUrl);
  };

  const onFileInputChanage = (e: any) => {
    const { files } = e.target;
    console.log("on file input change =>", files);
    const file = files && files.length ? files[0] : null;
    const imageUrl = getLocalUrl(file);
    console.log("image url =>", imageUrl);
    setUploadFileAfter(imageUrl);
  };

  useEffect(() => {
    getAPIs();
  }, []);

  return (
    <div>
      <HeaderBar btnBack={true} title="น.ส.รังสิมา แซ่หว่าง (EK-CNT60100015)" />
      <div style={{ padding: "20px 40px", margin: "10px 40px" }}>
        <h5>รายงานเคส Complication ของแผนก AESTHETICx1</h5>
        <Form
          form={form}
          // initialValues={}
          layout="vertical"
          className="form-primary"
          onFinish={(values: any) => {
            console.log("values =>", values);
          }}
          onFinishFailed={() => {
            message.warning(
              "กรุณาป้อนข้อมูลให้ถูกต้อง/Please enter valid information!"
            );
          }}
        >
          {/*-------------------------------------------------------------------------------------------------------------------*/}
          <div
            className="card-view col-12"
            style={{ padding: "40px 80px", flexDirection: "column" }}
          >
            <div className="row ">
              <div className="col-3">
                <Form.Item
                  name="code"
                  rules={[
                    {
                      required: false,
                      message: messageText,
                    },
                  ]}
                >
                  <Input
                    title="CN"
                    value={Channel}
                    onChange={(e) => {
                      setChannel(e.target.value);
                    }}
                  />
                </Form.Item>
              </div>
              <Input
                className="col-3"
                title="NAME"
                value={FirstName}
                onChange={(e) => {
                  setFirstName(e.target.value);
                }}
              />
              <div className="col-3"></div>
              <Input
                className="col-3"
                title="DATE"
                type="date"
                value={DateMain}
                onChange={(e) => {
                  setDateMain(e.target.value);
                }}
              />
            </div>
            <div className="row " style={{ marginTop: "20px" }}>
              <Input
                className="col-3"
                title="COMPLICATION NO."
                value={ComplicationNumber}
                onChange={(e) => {
                  setComplicationNumber(e.target.value);
                }}
              />
              <div className="col-3">
                <div style={{ color: "#aaa", fontSize: "14px" }}>
                  STATUS <br />
                  {Status}
                </div>
              </div>
            </div>
          </div>

          {/*-------------------------------------------------------------------------------------------------------------------*/}
          <div
            className="card-view mt-20"
            style={{
              padding: "40px 80px",
              flexDirection: "column",
            }}
          >
            <h5>
              <b>Procedure</b>
            </h5>
            <div className="row space-between" style={{ marginTop: "20px" }}>
              <div className="col-5">
                <b>Before</b>
              </div>
              <div className="col-5">
                <b>After</b>
              </div>
            </div>

            <div className="row space-between" style={{ marginTop: "20px" }}>
              <div className="col-5">
                <Input
                  className="col-12"
                  title="DATE"
                  type="date"
                  value={DateBefore}
                  onChange={(e) => {
                    setDateBefore(e.target.value);
                  }}
                />
              </div>
              <div className="col-5">
                <Input
                  className="col-12"
                  title="DATE"
                  type="date"
                  value={DateAfter}
                  onChange={(e) => {
                    setDateAfter(e.target.value);
                  }}
                />
              </div>
            </div>

            <div className="row space-between mt-20">
              <div className="col-5">
                <>
                  <div
                    className="box-image"
                    style={{
                      backgroundImage: `url('${uploadFileBefore}')`,
                      cursor: "pointer",
                    }}
                    onClick={onUploadIconClick}
                  >
                    {!uploadFileBefore ? (
                      <div id="rounded">
                        <Icon path={mdiImagePlus} size="30" color="#fff" />
                      </div>
                    ) : (
                      ""
                    )}
                    {!uploadFileBefore ? "อัปโหลดรูป" : ""}
                    <input
                      ref={fileInput}
                      type="file"
                      name="beforeImage"
                      style={{ display: "none" }}
                      onChange={(e) => {
                        onFileInputChange(e);
                      }}
                    />
                  </div>
                </>
              </div>
              <div className="col-5">
                <div
                  className="box-image"
                  style={{
                    backgroundImage: `url('${uploadFileAfter}')`,
                    cursor: "pointer",
                  }}
                  onClick={onUploadFileImage}
                >
                  {!uploadFileAfter ? (
                    <div id="rounded">
                      <Icon path={mdiImagePlus} size="30" color="#fff" />
                    </div>
                  ) : (
                    ""
                  )}
                  {!uploadFileAfter ? "อัปโหลดรูป" : ""}
                  <input
                    ref={inputFileImage}
                    type="file"
                    name="AfterImage"
                    style={{ display: "none" }}
                    onChange={(e) => {
                      onFileInputChanage(e);
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="row space-between mt-20">
              <div className="col-5">
                <Textarea
                  placeholder="Procedure detail..."
                  value={ProductDetailBefore}
                  onChange={(e) => {
                    setProductDetailBefore(e.target.value);
                  }}
                />
              </div>
              <div className="col-5">
                <Textarea
                  placeholder="Procedure detail..."
                  value={ProductDetailAfter}
                  onChange={(e) => {
                    setProductDetailAfter(e.target.value);
                  }}
                />
              </div>
            </div>

            <h5 className="mt-20">
              <b>Complication</b>
            </h5>
            <Textarea
              placeholder="กรอก Complimentation"
              value={Complication}
              onChange={(e) => {
                setComplication(e.target.value);
              }}
            />

            <h5 className="mt-20">
              <b>ความเห็นแพทย์ผ่าตัด</b>
            </h5>
            <Textarea
              placeholder="ความเห็นแพทย์ผ่าตัด"
              value={CommentDoctor}
              onChange={(e) => {
                setCommentDoctor(e.target.value);
              }}
            />

            <h5 className="mt-20">
              <b>ความเห็นผู้อำนวยการแพทย์</b>
            </h5>
            <Textarea
              placeholder="ความเห็นผู้อำนวยการแพทย์"
              value={CommentDirector}
              onChange={(e) => {
                setCommentDirector(e.target.value);
              }}
            />

            <h5 className="mt-20">
              <b>ความเห็นกรรมการผู้จัดการ</b>
            </h5>
            <Textarea
              placeholder="ความเห็นกรรมการผู้จัดการ"
              value={ManagingDirector}
              onChange={(e) => {
                setManagingDirector(e.target.value);
              }}
            />
            <h5 className="mt-20">
              <b>ประเมินค่าใช้จ่าย</b>
            </h5>
            <Textarea
              rows={1}
              placeholder="จำนวนเงินรวม"
              value={CostEstiMate}
              onChange={(e) => {
                setCostEstiMate(e.target.value);
              }}
            />
          </div>
          {/*-------------------------------------------------------------------------------------------------------------------*/}
          <div
            className="card-view mt-20"
            style={{
              padding: "40px 80px",
              flexDirection: "column",
            }}
          >
            <div className="row space-between">
              <Input
                className="col-5"
                title="ผู้จัดทำ"
                value={Organizer}
                onChange={(e) => {
                  setOrganizer(e.target.value);
                }}
              />
              <Input
                className="col-5"
                title="SALE"
                value={Sale}
                onChange={(e) => {
                  setSale(e.target.value);
                }}
              />
            </div>
          </div>
        </Form>

        <div className="justify-center mt-20">
          <MainButton
            title="บันทึกรายงาน"
            // to="/opd/list/EK-CNT60100015/view/view-complication"
            isSubmit={true}
            form={form}
          />
        </div>
      </div>
    </div>
  );
};
export default Complication;
